// extracted by mini-css-extract-plugin
export var blog = "blog-module--blog--TbHSA";
export var categoriesWrapper = "blog-module--categories-wrapper--f7auu";
export var titleHeader = "blog-module--title-header--l+AjD";
export var titleSectionWrapper = "blog-module--title-section-wrapper---Ra4F";